type StepperProps = {
  steps: string[]
  activeIndex: number
}

export function Stepper({ steps, activeIndex }: StepperProps) {
  return (
    <div className="flex items-stretch">
      {steps.map((label, i) => (
        <div
          key={label}
          className={`px-2 sm:px-3 md:px-4 flex items-center ${
            i === activeIndex ? 'border-b-2 border-[#0B2540]' : 'border-b-2 border-transparent'
          }`}
        >
          <span
            className={`text-[10px] sm:text-xs font-semibold tracking-wide sm:tracking-wider uppercase whitespace-nowrap ${
              i === activeIndex ? 'text-[#0B2540]' : 'text-gray-400'
            }`}
          >
            {label}
          </span>
        </div>
      ))}
    </div>
  )
}
